export default __webpack_public_path__ + "static/media/simple-play.a238eb9d.svg";